import React, { useState, useCallback, useEffect, useContext } from 'react';
import _ from 'lodash';
import ProductsWithFilterPicker from '../../../../Components/Store/ProductsWithFilterPicker/ProductsWithFilterPicker.js';
import Tags from '../../../../Components/Queries/Tags.js';
import Authors from '../../../../Components/Queries/Authors.js';
import { groupAndSimplifyTags } from '../../../../helpers/productTagFilter.js';
import { convertLangCodeToGraphqlEnum } from '../../../../helpers/locale.js';
import { getEnvVar } from '../../../../helpers/env.js';
import { LocaleContext } from '../../../../Context';
import SearchResultsSkeleton from '../../../../Components/Skeletons/SearchResultsSkeleton.js';
import { useTranslation } from 'react-i18next';
import PageTitle from '../../../../Components/PageTitle.js';

// featured author ids are hardcoded in the client side env for now
// in the future they may be based e.g. on automatically generated author popularity
const featuredAuthorIds = getEnvVar('FEATURED_AUTHOR_IDS')
  .split(',')
  .map(id => parseInt(id));

const AllProducts = () => {
  const { locale } = useContext(LocaleContext);
  const [contentLanguage, setContentLanguage] = useState('');

  const { t } = useTranslation();

  const handleContentLanguageChange = useCallback((language) => {
    setContentLanguage(language);
  }, [setContentLanguage]);

  useEffect(() => {
    // only set the contentLanguage when the page loads
    if (!contentLanguage) {
      setContentLanguage(locale.language);
    }
  }, [locale.language, contentLanguage]);

  if (!locale || !contentLanguage) {
    return <SearchResultsSkeleton />;
  }

  const allProductsText = t('all-products');

  return (
    <>
      <PageTitle title={t('all-products')} />
      <Tags groups='all'>
        {(tagData) => (
          <Authors>
            {(authorData) => {
              const filteredAuthors = _.filter(authorData, (author) => (
                author.products.length > 0 &&
                author.language === convertLangCodeToGraphqlEnum(contentLanguage)
              ));
              const allTags = groupAndSimplifyTags(tagData, filteredAuthors, featuredAuthorIds, contentLanguage);

              return (
                <ProductsWithFilterPicker
                  headerText={allProductsText}
                  availableTagsByGroupName={allTags}
                  showContentLanguagePicker={locale.language === 'nl-nl'}
                  contentLanguage={contentLanguage}
                  onContentLanguageChange={handleContentLanguageChange}
                />
              );
            }}
          </Authors>
        )}
      </Tags>
    </>
  );
};

export default AllProducts;
